import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import getMyOutlookProductStore, {
    EMPTY_CREDITS_STATE,
    EMPTY_ELIGIBILITY_STATE,
    EMPTY_PRODUCT_STATE,
    type MyOutlookCreditsState,
    type MyOutlookEligibilityState,
    type MyOutlookProductState,
} from '../store/myOutlookProductStore';

export function getMyOutlookContextKey(mailboxInfo: MailboxInfo): string {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const store = getMyOutlookProductStore();
    return `${accountKey}:${store.contextEpoch}:${store.accountEpochs[accountKey] ?? 0}`;
}

export function getMyOutlookProductState(mailboxInfo: MailboxInfo): MyOutlookProductState {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const context = getMyOutlookProductStore().contextsByAccount[accountKey];
    return context?.ownerKey === accountKey ? context.product : EMPTY_PRODUCT_STATE;
}

export function getMyOutlookCreditsState(mailboxInfo: MailboxInfo): MyOutlookCreditsState {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const context = getMyOutlookProductStore().contextsByAccount[accountKey];
    return context?.ownerKey === accountKey ? context.credits : EMPTY_CREDITS_STATE;
}

export function getMyOutlookEligibilityState(mailboxInfo: MailboxInfo): MyOutlookEligibilityState {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const context = getMyOutlookProductStore().contextsByAccount[accountKey];
    return context?.ownerKey === accountKey ? context.eligibility : EMPTY_ELIGIBILITY_STATE;
}
